import React from "react";

const Footer = () => {
  return (
    <footer className="border-t border-gray-800 py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="text-2xl font-bold text-[hsl(30,100%,85%)] mb-4">
              Inika
            </div>
            <p className="text-gray-400">
              The unified, AI-native e-commerce platform that's 30+% cheaper and 10x easier than traditional platforms.
            </p>
          </div>
          <div></div>
          <div></div>
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Address</h3>
            <div className="text-gray-400">
              <p>823 Congress Avenue,</p>
              <p>Austin, TX, 78701</p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; 2025 Project Inika, Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 